(() => {
  'use strict';
  const configElement = document.getElementById('RunaConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const dialog = document.getElementById('RunaCart');
  let opener;
  let busy = false;
  function initializeBundles(scope = document) {
    const selector = '[data-runa-product-form] kaching-bundles-block[config]';
    const widgets = scope.matches?.(selector) ? [scope] : scope.querySelectorAll(selector);
    widgets.forEach(widget => {
      try {
        const options = JSON.parse(widget.getAttribute('config'));
        if (!options.ignoreDeselect) {
          options.ignoreDeselect = true;
          widget.setAttribute('config', JSON.stringify(options));
        }
        const attribute = widget.getAttribute('deal-block');
        if (!attribute) return;
        const dealBlock = JSON.parse(attribute);
        let changed = false;
        (dealBlock.dealBars || []).forEach(dealBar => {
          (dealBar.freeGifts || []).forEach(gift => {
            if (gift.giftType !== 'shipping') return;
            gift.giftType = 'product';
            gift.productGID = null;
            gift.variantGIDs = null;
            changed = true;
          });
        });
        if (changed) widget.setAttribute('deal-block', JSON.stringify(dealBlock));
      } catch (error) { return; }
    });
  }
  new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') initializeBundles(mutation.target);
      else for (const added of mutation.addedNodes) {
        if (added.nodeType === 1) initializeBundles(added);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['config', 'deal-block'] });
  initializeBundles();
  const money = (cents, currency = config.currency) => cents === 0 ? config.labels.free : new Intl.NumberFormat(config.locale, { style: 'currency', currency }).format(cents / 100);
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  async function request(path, options = {}) {
    const response = await fetch(`${root}${path}`, { credentials: 'same-origin', ...options });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || config.labels.error);
    return result;
  }
  function showError(error) {
    const target = dialog?.querySelector('[data-runa-cart-error]');
    if (target) { target.textContent = error.message || config.labels.error; target.hidden = false; }
  }
  let paymentRevision = 0;
  async function refreshCartPayments(cart) {
    const revision = ++paymentRevision;
    const target = dialog?.querySelector('[data-runa-cart-payments]');
    if (!target) return;
    target.replaceChildren();
    if (!cart.item_count) return;
    target.setAttribute('aria-busy', 'true');
    try {
      const sections = await request('?sections=runa-cart-payments');
      if (revision !== paymentRevision) return;
      const html = sections['runa-cart-payments'];
      if (!html) throw new Error(config.labels.paymentsError);
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-runa-payment-section]');
      if (!section) throw new Error(config.labels.paymentsError);
      target.replaceChildren(...section.childNodes);
    } catch (error) {
      if (revision === paymentRevision) target.append(node('p', config.labels.paymentsError, 'runa-muted'));
    } finally {
      if (revision === paymentRevision) target.removeAttribute('aria-busy');
    }
  }
  let cartDeadline = null;
  const timerKey = 'runa-cart-checkout-deadline';
  function syncCartTimer(itemCount) {
    const timers = document.querySelectorAll('[data-runa-cart-timer]');
    if (!timers.length) return;
    timers.forEach(timer => { timer.hidden = !itemCount; });
    if (!itemCount) {
      cartDeadline = null;
      try { sessionStorage.removeItem(timerKey); } catch (error) {}
      return;
    }
    if (cartDeadline === null) {
      try { cartDeadline = Number(sessionStorage.getItem(timerKey)) || null; } catch (error) {}
      if (cartDeadline === null) {
        cartDeadline = Date.now() + Number(timers[0].dataset.duration) * 1000;
        try { sessionStorage.setItem(timerKey, String(cartDeadline)); } catch (error) {}
      }
    }
    tickCartTimer();
  }
  function tickCartTimer() {
    if (cartDeadline === null) return;
    const remaining = Math.max(0, Math.ceil((cartDeadline - Date.now()) / 1000));
    const time = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
    document.querySelectorAll('[data-runa-cart-timer]').forEach(timer => {
      const clock = timer.querySelector('[data-runa-cart-clock]');
      clock.textContent = time;
      clock.hidden = remaining === 0;
      clock.previousElementSibling.hidden = remaining === 0;
      timer.querySelector('[data-runa-timer-expired]').hidden = remaining !== 0;
    });
  }
  syncCartTimer(config.itemCount);
  setInterval(tickCartTimer, 1000);
  function renderCart(cart) {
    document.querySelectorAll('[data-runa-cart-count]').forEach(element => { element.textContent = cart.item_count; });
    syncCartTimer(cart.item_count);
    if (!dialog) return;
    const items = dialog.querySelector('[data-runa-cart-items]');
    items.replaceChildren();
    dialog.querySelector('[data-runa-cart-error]').hidden = true;
    dialog.querySelector('[data-runa-cart-footer]').hidden = !cart.item_count;
    const isGoneRuna = item => String(item.product_id) === String(config.gonerunaProductId);
    dialog.querySelector('[data-runa-goneruna-proof]').hidden = !cart.items.some(isGoneRuna);
    dialog.querySelector('[data-runa-cart-shipping-row]').hidden = !cart.items.length;
    const savings = cart.total_discount || 0;
    dialog.querySelector('[data-runa-cart-savings-row]').hidden = savings === 0;
    dialog.querySelector('[data-runa-cart-savings]').textContent = savings ? `−${money(savings, cart.currency)}` : '';
    refreshCartPayments(cart);
    if (!cart.items.length) {
      items.append(node('p', config.labels.empty));
      const continueLink = node('a', config.labels.continue, 'runa-button');
      continueLink.href = config.catalog; items.append(continueLink);
    }
    cart.items.forEach(item => {
      const row = node('article', undefined, 'runa-cart-row');
      const info = node('div');
      const link = node('a', item.product_title);
      link.href = item.url;
      const title = node('h3'); title.append(link); info.append(title);
      if (item.variant_title) info.append(node('p', item.variant_title, 'runa-muted'));
      Object.entries(item.properties || {}).forEach(([name, value]) => {
        if (!name.startsWith('_') && value) info.append(node('p', `${name}: ${value}`, 'runa-muted'));
      });
      if (item.selling_plan_allocation) info.append(node('p', item.selling_plan_allocation.selling_plan.name, 'runa-muted'));
      if (item.image) {
        const image = node('img'); image.src = item.image; image.alt = item.product_title; image.width = 65; image.height = 65; row.append(image);
      } else row.append(node('span'));
      const prices = node('p', undefined, 'runa-cart-line-price');
      if (item.original_line_price > item.final_line_price) prices.append(node('s', money(item.original_line_price, cart.currency)));
      prices.append(node('strong', money(item.final_line_price, cart.currency), item.final_line_price === 0 ? 'runa-free' : ''));
      if (item.final_line_price > 0 && item.original_line_price > item.final_line_price) {
        const percent = Math.round((item.original_line_price - item.final_line_price) / item.original_line_price * 100);
        prices.append(node('span', config.labels.savedPercent.replace('[percent]', percent), 'runa-cart-saved'));
      }
      info.append(prices);
      const controls = node('div', undefined, 'runa-cart-controls');
      const label = node('label', config.labels.quantity);
      const quantity = node('input'); quantity.type = 'number'; quantity.min = '0'; quantity.step = '1'; quantity.value = item.quantity;
      quantity.dataset.runaLineKey = item.key; label.append(quantity); controls.append(label);
      const remove = node('button', config.labels.remove); remove.type = 'button'; remove.dataset.runaRemoveKey = item.key; controls.append(remove); info.append(controls);
      (item.line_level_discount_allocations || []).forEach(discount => info.append(node('p', discount.discount_application.title, 'runa-cart-discount')));
      row.append(info); items.append(row);
    });
    (cart.cart_level_discount_applications || []).forEach(discount => items.append(node('p', discount.title, 'runa-muted')));
    dialog.querySelector('[data-runa-cart-total]').textContent = money(cart.total_price, cart.currency);
    dialog.querySelector('[data-runa-checkout]').disabled = !cart.item_count;
    document.dispatchEvent(new CustomEvent('runa:cart-updated', { detail: { cart } }));
  }
  function showCartLoading(trigger) {
    if (!dialog || config.cartMode === 'page' || !dialog.showModal) return false;
    opener = trigger || document.activeElement;
    dialog.querySelector('[data-runa-cart-error]').hidden = true;
    dialog.querySelector('[data-runa-cart-footer]').hidden = true;
    dialog.querySelector('[data-runa-checkout]').disabled = true;
    const status = node('p', config.labels.cartLoading, 'runa-muted');
    status.setAttribute('role', 'status');
    dialog.querySelector('[data-runa-cart-items]').replaceChildren(status);
    if (!dialog.open) dialog.showModal();
    document.body.style.overflow = 'hidden';
    return true;
  }
  async function openCart(trigger) {
    if (!dialog || config.cartMode === 'page' || !dialog.showModal) { window.location.assign(config.cart); return; }
    showCartLoading(trigger);
    try {
      renderCart(await request('cart.js'));
    } catch (error) { window.location.assign(config.cart); }
  }
  async function changeLine(key, quantity) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    busy = true;
    dialog.setAttribute('aria-busy', 'true');
    dialog.querySelector('[data-runa-cart-payments]').inert = true;
    dialog.querySelectorAll('input, button').forEach(element => { element.disabled = true; });
    try {
      const cart = await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      renderCart(cart);
    } catch (error) { showError(error); }
    finally {
      busy = false; dialog.removeAttribute('aria-busy');
      dialog.querySelector('[data-runa-cart-payments]').inert = false;
      dialog.querySelectorAll('input, button').forEach(element => { element.disabled = false; });
      if (!dialog.querySelector('[data-runa-line-key]')) dialog.querySelector('[data-runa-checkout]').disabled = true;
    }
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-runa-cart-open]');
    if (open && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) { event.preventDefault(); openCart(open); }
    if (event.target.closest('[data-runa-cart-close]')) dialog?.close();
    const remove = event.target.closest('[data-runa-remove-key]');
    if (remove) changeLine(remove.dataset.runaRemoveKey, 0);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-runa-line-key]')) changeLine(event.target.dataset.runaLineKey, Number(event.target.value));
    if (event.target.matches('[data-runa-variant]')) {
      const form = event.target.closest('form');
      const option = event.target.selectedOptions[0];
      const area = form.closest('[data-runa-product]');
      const price = area.querySelector('[data-runa-price]');
      if (price) price.textContent = option.dataset.price;
      const compare = area.querySelector('[data-runa-compare]');
      if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      const button = form.querySelector('[name="add"]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? config.labels.soldOut : config.labels.add;
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-runa-product-form]');
    if (!form || event.defaultPrevented || config.cartMode === 'page') return;
    event.preventDefault();
    if (form.dataset.submitting) return;
    form.dataset.submitting = 'true';
    const button = form.querySelector('[name="add"]');
    const errorArea = form.querySelector('[data-runa-product-error]');
    const data = new FormData(form);
    button.disabled = true; errorArea.hidden = true;
    let cartPending = false;
    try {
      const widget = form.querySelector('kaching-bundles-block');
      let options = { method: 'POST', body: data };
      if (widget) {
        if (typeof widget.items !== 'function') throw new Error(config.labels.bundleLoading);
        const validation = widget.validateItemSelection?.();
        if (validation && !validation.valid) throw new Error(config.labels.chooseOptions);
        const selected = widget.items();
        if (!Array.isArray(selected) || !selected.length) throw new Error(config.labels.chooseOptions);
        const items = selected.map(item => {
          const quantity = Number(item.quantity);
          if (!/^\d+$/.test(String(item.id)) || !Number.isInteger(quantity) || quantity < 1) throw new Error(config.labels.chooseOptions);
          const line = { id: item.id, quantity, properties: { ...(item.properties || {}) } };
          if (item.selling_plan) line.selling_plan = item.selling_plan;
          if (item.parent_id) line.parent_id = item.parent_id;
          return line;
        });
        options = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) };
      }
      cartPending = showCartLoading(button);
      await request('cart/add.js', options);
      if (cartPending) renderCart(await request('cart.js'));
      else await openCart(button);
    } catch (error) {
      errorArea.textContent = error.message; errorArea.hidden = false;
      if (cartPending) {
        dialog.querySelector('[data-runa-cart-items]').replaceChildren();
        showError(error);
        const cartLink = node('a', config.labels.viewCart, 'runa-cart-view');
        cartLink.href = config.cart;
        dialog.querySelector('[data-runa-cart-items]').append(cartLink);
      }
    }
    finally { button.disabled = false; delete form.dataset.submitting; }
  });
  dialog?.addEventListener('close', () => { document.body.style.overflow = ''; opener?.focus(); });
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  function initializeAddresses(scope = document) {
    scope.querySelectorAll('[data-runa-address-country]').forEach(country => {
      if (country.dataset.ready) return;
      country.dataset.ready = 'true';
      const province = country.closest('form').querySelector('[data-runa-address-province]');
      if (country.dataset.default) country.value = country.dataset.default;
      function updateProvince() {
        const options = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
        province.replaceChildren();
        options.forEach(([value, label]) => {
          const option = node('option', label); option.value = value; province.append(option);
        });
        province.disabled = !options.length;
        province.closest('[data-runa-province-wrap]').hidden = !options.length;
      }
      updateProvince();
      if (province.dataset.default) province.value = province.dataset.default;
      country.addEventListener('change', updateProvince);
    });
  }
  initializeAddresses();
  document.addEventListener('shopify:section:load', event => initializeAddresses(event.target));
})();



(() => {
  document.addEventListener('click', event => {
    const root = document.querySelector('.dana.dana--open');
    if (!root) return;
    const path = event.composedPath();
    if (path.some(element => element instanceof Element && element.matches('.dana__panel, .dana__launcher'))) return;
    root.querySelector('.dana__close')?.click();
  });
})();
